import { Directive } from '@angular/core';
import { ValidatorFn, AbstractControl, FormGroup, FormControl } from '@angular/forms';

@Directive({
  selector: '[appMobileValidation]'
})
export class MobileValidationDirective {

  constructor() { }

}

export function confirmMobileValidation(form: FormGroup): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
     let primaryMobileVal = form.controls['primaryMobilePhone'].value;
     if (primaryMobileVal) {
      if (primaryMobileVal === control.value) {
        return { 'confirmMobileValidation': { value: control.value } };
      } else {
        return null;
      }
     } else {
       return null;
     }
    } else {
      return null;
    }
  };
}
